import { createSelector } from 'reselect';

const getValue = (inputValue) => {
  if (!inputValue) {
    return inputValue;
  }
  if (inputValue === 'true') {
    return true;
  }
  if (inputValue === 'false') {
    return false;
  }
  const intValue = parseInt(inputValue, 10);
  if (intValue.toString() === inputValue) {
    return intValue;
  }
  if (typeof inputValue === 'string') {
    const maybeArray = inputValue.split(',');
    if (maybeArray && maybeArray.length > 1) {
      return maybeArray.map(getValue);
    }
  }
  return inputValue;
};

const getLocationState = (state) => state.location || {};

const getQueryParamsRaw = createSelector([getLocationState], (l) => l.query || {});

const getPresetsParamsRaw = createSelector([getLocationState], (l) => l.presets || {});

const getMergedParams = createSelector(
  [getQueryParamsRaw, getPresetsParamsRaw],
  (query, presets) => ({ ...presets, ...query }),
);

export const getQueryParams = createSelector([getMergedParams], (rawParams) => {
  return Object.keys(rawParams).reduce((acc, key) => {
    return {
      ...acc,
      [key]: getValue(rawParams[key]),
    };
  }, {});
});
